import './TextInput.less';
import React from 'react';
import Icon from "../icon/Icon";

export default class TextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: TextInput.normalizeValue(this.props.defaultValue),
            focused: false,
            passwordShown: false
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            state.value = TextInput.normalizeValue(props.value);
            return state;
        }
        return null;
    }

    static normalizeValue = (value) => {
        return 'string' === typeof value ? value.trim() : '';
    };

    setValue = (value) => {
        const {onChange} = this.props;

        this.setState({
            value: value
        }, onChange ? () => {
            onChange(this.getOutputText());
        } : undefined);
    };

    getOutputText = () => {
        const {trimmed} = this.props;
        const {value} = this.state;

        if (trimmed) {
            return value.trim();
        }

        return value;
    };

    onFocus = () => {
        this.setState({
            focused: true
        });
    };

    onBlur = () => {
        this.setState({
            focused: false
        });
    };

    togglePasswordShown = () => {
        this.setState(prevState => {
            return {
                passwordShown: !prevState.passwordShown
            };
        });
    };

    render() {
        const {maxLength, multipleLines, numberOfRows, disabled, appearance, style, passwordCanShow, placeholder} = this.props;
        const {value, focused, passwordShown} = this.state;

        const currentLength = this.getOutputText().length;

        return <div
            className={
                `text-input appearance-${appearance}`
                + (multipleLines ? ' multiple-lines' : '')
                + (focused ? ' focused' : '')
                + (disabled ? ' disabled' : '')
            }
            onClick={() => this.inputEl.focus()}
        >
            {
                multipleLines
                    ? <textarea
                        onKeyUp={event => this.setValue(event.target.value)}
                        onChange={event => this.setValue(event.target.value)}
                        onPaste={event => this.setValue(event.target.value)}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        placeholder={placeholder}
                        value={value}
                        rows={numberOfRows}
                        disabled={disabled}
                        ref={el => this.inputEl = el}
                    />
                    : <input
                        onKeyUp={event => this.setValue(event.target.value)}
                        onChange={event => this.setValue(event.target.value)}
                        onPaste={event => this.setValue(event.target.value)}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        type={style === 'password' && passwordShown ? 'text' : style}
                        placeholder={placeholder}
                        value={value}
                        disabled={disabled}
                        ref={el => this.inputEl = el}
                    />
            }
            {
                maxLength &&
                <div
                    className={
                        'character-counter'
                        + (currentLength > maxLength ? ' invalid' : '')
                    }
                >
                    {currentLength}/{maxLength}
                </div>
            }
            {
                style === 'password' &&
                passwordCanShow &&
                <button
                    type="button"
                    tabIndex="-1"
                    className={`password-toggle ${passwordShown ? 'active' : ''}`}
                    onClick={() => this.togglePasswordShown()}
                >
                    <Icon name="eye"/>
                </button>
            }
        </div>;
    }
}


TextInput.defaultProps = {
    maxLength: undefined,
    multipleLines: false,
    numberOfRows: 3,
    disabled: false,
    appearance: 'box',
    style: 'text',
    passwordCanShow: false,
    placeholder: undefined,
    trimmed: true
};
